// Generated types for Unit
// This file is auto-generated - do not edit manually

import { z } from 'zod';

import { CatalogNodeReadAPI, CatalogNodeWriteAPI } from '../../shared/types/catalognode';
import { RFLPElementReadAPI, RFLPElementWriteAPI } from './rflpelement';
import { CatalogNodeReadAPISchemaObject, CatalogNodeWriteAPISchemaObject } from '../../shared/types/catalognode';
import { RFLPElementReadAPISchemaObject, RFLPElementWriteAPISchemaObject } from './rflpelement';

// ============================================================================
// TypeScript Interfaces
// ============================================================================

export interface UnitReadAPI extends CatalogNodeReadAPI, RFLPElementReadAPI {
  /** Canonical short symbol (e.g. 'V', 'Nm', 'Pa', 'degC'). */
  symbol: string;
  /** Physical dimension, either SI-style ('M·L²·T⁻²·I⁻¹') or categorical ('voltage', 'torque', 'pressure'). Used to validate unit conversions. */
  dimension?: string | null;
  /** Coarse grouping (electrical / mechanical / thermal / fluidic / ...). */
  category?: string | null;
  /** Multiplicative factor to canonical SI (e.g. inch-lb → Nm is 0.1129848). */
  si_factor?: number | null;
  /** Additive offset to canonical SI (e.g. degC → K is +273.15). */
  si_offset?: number | null;
  /** True if this Unit is the canonical SI unit for its dimension. */
  is_si_canonical?: boolean;
}

export interface UnitWriteAPI extends CatalogNodeWriteAPI, RFLPElementWriteAPI {
  /** Canonical short symbol (e.g. 'V', 'Nm', 'Pa', 'degC'). */
  symbol: string;
  /** Physical dimension, either SI-style ('M·L²·T⁻²·I⁻¹') or categorical ('voltage', 'torque', 'pressure'). Used to validate unit conversions. */
  dimension?: string | null;
  /** Coarse grouping (electrical / mechanical / thermal / fluidic / ...). */
  category?: string | null;
  /** Multiplicative factor to canonical SI (e.g. inch-lb → Nm is 0.1129848). */
  si_factor?: number | null;
  /** Additive offset to canonical SI (e.g. degC → K is +273.15). */
  si_offset?: number | null;
  /** True if this Unit is the canonical SI unit for its dimension. */
  is_si_canonical?: boolean;
}

// ============================================================================
// Zod Schemas
// ============================================================================

export const UnitReadAPISchema: z.ZodType<UnitReadAPI> = CatalogNodeReadAPISchemaObject.extend(RFLPElementReadAPISchemaObject.shape).extend({
  symbol: z.string(),
  dimension: z.string().nullable().optional(),
  category: z.string().nullable().optional(),
  si_factor: z.number().nullable().optional(),
  si_offset: z.number().nullable().optional(),
  is_si_canonical: z.boolean().optional(),
}).passthrough();

export const UnitWriteAPISchema: z.ZodType<UnitWriteAPI> = CatalogNodeWriteAPISchemaObject.extend(RFLPElementWriteAPISchemaObject.shape).extend({
  symbol: z.string(),
  dimension: z.string().nullable().optional(),
  category: z.string().nullable().optional(),
  si_factor: z.number().nullable().optional(),
  si_offset: z.number().nullable().optional(),
  is_si_canonical: z.boolean().optional(),
}).passthrough();
